import {TextField} from '@material-ui/core'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import createReportFolder from 'modules/reports/api/reportFolders/createReportFolder'
import {useReportsFolderSidebarContext} from 'modules/reports/components/Folder/Sidebar/ReportsFolderSidebar.context'
import useCore from 'modules/reports/hooks/core'
import authStore from 'modules/reports/stores/auth'
import React, {KeyboardEvent, useState} from 'react'
import ReportsFolderSidebarItem from '../Item'
import useStyles from './ReportsFolderSidebarAdd.styles'

function ReportsFolderSidebarAdd() {
  const folderSidebarContext = useReportsFolderSidebarContext()
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'components', 'FolderSidebarAdd')
  const [status, setStatus] = useState<'text' | 'editing' | Promise<any>>('text')
  const [name, setName] = useState('')

  const persisting = typeof status !== 'string'

  function reset() {
    setName('')
    setStatus('text')
  }

  function handleNameChange(event) {
    setName(event.target.value)
  }

  function handleTextClick() {
    setStatus('editing')
  }

  async function handleAdd() {
    if (!name) return setStatus('text')

    const promise = createReportFolder({accountId: authStore.user.id, name})
    setStatus(promise)

    const response = await promise
    folderSidebarContext.onCreate(response.data)

    reset()
  }

  function handleKeyDown(event: KeyboardEvent) {
    switch (event.key) {
      case 'Enter':
        return handleAdd()
      case 'Escape':
        return reset()
      default:
        break
    }
  }

  function renderText() {
    return (
      <>
        <AddCircleIcon className={classes.icon} /> {pt('title')}
      </>
    )
  }

  function renderInput() {
    return (
      <TextField
        value={name}
        onChange={handleNameChange}
        onBlur={handleAdd}
        label={pt('label')}
        data-testid={p('input')}
        disabled={persisting}
        onKeyDown={handleKeyDown}
        autoFocus
        variant="outlined"
        size="small"
      />
    )
  }

  return (
    <ReportsFolderSidebarItem onClick={handleTextClick} data-testid={p()}>
      {status === 'text' ? renderText() : renderInput()}
    </ReportsFolderSidebarItem>
  )
}

export default ReportsFolderSidebarAdd
